import React from "react";
import { useIntl } from "react-intl";
import useOnClickOutside from "use-onclickoutside";

export const PopupMenuV2 = ({
  editLabel,
  deleteLabel,
  onEditClick,
  onDeleteClick,
  close = () => {},
  isDeletedDisabled = false,
  isEditDisabled = false,
  deleteLeadingIcon = null,
  editLeadingIcon = null,
  showEditButton = true,
  showDeleteButton = true,
  showViewButton = false,
  viewLabel,
  onViewClick,
  viewLeadingIcon = null,
  isViewDisabled = false,
  labelClassName = "",
  parentClassName = "",
}) => {
  const { messages } = useIntl();
  const ref = React.useRef(null);

  useOnClickOutside(ref, close);

  return (
    <div className={`popup-menu-v2 ${parentClassName}`} ref={ref}>
      <div className="popup-menu-v2-item-list">
        {showViewButton && (
          <span
            className={`popup-menu-v2-item-label view ${labelClassName} ${
              isViewDisabled
                ? "pointer-events-none opacity-30"
                : "cursor-pointer"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              if (!isViewDisabled) {
                close();
                onViewClick?.();
              }
            }}
          >
            {viewLeadingIcon ? (
              <span className="popup-menu-v2-item-label-content">
                {viewLeadingIcon}
                <span>{viewLabel || messages?.common?.view}</span>
              </span>
            ) : (
              viewLabel || messages?.common?.view
            )}
          </span>
        )}
        {showEditButton && (
          <span
            className={`popup-menu-v2-item-label edit ${labelClassName} ${
              isEditDisabled
                ? "pointer-events-none opacity-30"
                : "cursor-pointer"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              if (!isEditDisabled) {
                close();
                onEditClick?.();
              }
            }}
          >
            {editLeadingIcon ? (
              <span className="popup-menu-v2-item-label-content">
                {editLeadingIcon}
                <span>{editLabel || messages?.common?.edit}</span>
              </span>
            ) : (
              editLabel || messages?.common?.edit
            )}
          </span>
        )}
        {showDeleteButton && (
          <span
            className={`popup-menu-v2-item-label delete ${labelClassName} ${
              isDeletedDisabled
                ? "pointer-events-none opacity-30"
                : "cursor-pointer"
            }`}
            onClick={(e) => {
              e.stopPropagation();
              if (!isDeletedDisabled) {
                close();
                onDeleteClick?.();
              }
            }}
          >
            {deleteLeadingIcon ? (
              <span className="popup-menu-v2-item-label-content">
                {deleteLeadingIcon}
                <span>{deleteLabel || messages?.common?.delete}</span>
              </span>
            ) : (
              deleteLabel || messages?.common?.delete
            )}
          </span>
        )}
      </div>
    </div>
  );
};

export const ActionPopup = ({
  actions = [],
  close = () => {},
  position = "bottom",
}) => {
  const ref = React.useRef(null);

  useOnClickOutside(ref, close);

  return (
    <div className={`popup-menu-v2 ${position}`} ref={ref}>
      <div className="popup-menu-v2-item-list">
        {actions?.map((action, index) => {
          return (
            <span
              key={`action-${index}`}
              className={`popup-menu-v2-item-label ${action.className}`}
              onClick={action.onClick}
            >
              {action.icon ? (
                <span className="popup-menu-v2-item-label-content">
                  {action.icon}
                  <span>{action.label}</span>
                </span>
              ) : (
                action.label
              )}
            </span>
          );
        })}
      </div>
    </div>
  );
};
